import { useGoogleAnalytics } from "@connectaryal/google-analytics";
import { Button } from "@fluentui/react-components";
import PropTypes from "prop-types";
import * as React from "react";
import { useSelector } from "react-redux";

const TrackedButton = React.forwardRef(function TrackedButton(props, ref) {
  const { trackEngagement } = useGoogleAnalytics();
  const presentationHash = useSelector((state) => state.app.presentation.hash);
  return (
    <Button
      {...props}
      ref={ref}
      onClick={(e) => {
        if (props.onClick) props.onClick(e);
        trackEngagement({
          type: "click",
          options: {
            id: props?.id ?? props?.key ?? "UNIDENTIFIED",
            presId: presentationHash,
          },
        });
      }}
    />
  );
});

TrackedButton.propTypes = {
  id: PropTypes.string,
  key: PropTypes.string,
  onClick: PropTypes.func,
};

export default TrackedButton;
